import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import useGetUserTileInfo from '../useGetUserTileInfo';

function useTrackMegaUserInfo() {
  const { trackEvent } = useContext(AnalyticsContext);
  const data = useGetUserTileInfo();
  const fireEvent = () => {
    trackEvent('mega-srp-user-info', data, undefined, {
      useFetch: true,
      fetchOption: { keepalive: false }
    });
  };

  return {
    data,
    fireEvent
  };
}

export default useTrackMegaUserInfo;
